import styled from "styled-components";

const ProfileImage = styled.img`
  position: relative;
  width: 70px;
  height: 70px;
  border-radius: 5%;
  object-fit: cover;
`;

export default ProfileImage;
